import { RichTextBlock } from "@/components/cms-puck/blocks/text-blocks";
import { ArtworkSelectionPreview } from "@/components/cms-puck/blocks/catalogue-previews";
import { useSelectionCategoryPreview } from "@/context/cms-puck/SelectionCategoryPreviewContext";
import { useCmsNew } from "@/lib/cms/cms-new-i18n";
import type { BlockStyle } from "@/lib/cms-puck/block-style";
import {
  DEFAULT_SELECTION_VISIBILITY,
  selectionCategoryPlainTitle,
  type SelectionAlignment,
  type SelectionDisplayMode,
  type SelectionVisibility,
} from "@/lib/cms-puck/blocks/selection";

export function SelectionCategoryTitlePreview({
  align = "center",
  style,
}: {
  align?: "left" | "center" | "right";
  /** Conservé pour layouts hérités ; le niveau vient du HTML TipTap. */
  level?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  style?: BlockStyle;
}) {
  const cmsNew = useCmsNew();
  const { category } = useSelectionCategoryPreview();
  const fallback = cmsNew(
    "cms.new.preview.selectionSections.category",
    "Catégorie",
  );
  const titleHtml =
    category?.title?.trim() ||
    `<p>${selectionCategoryPlainTitle(category?.title) || fallback}</p>`;

  return (
    <div className={category ? undefined : "opacity-60"}>
      <RichTextBlock body={titleHtml} align={align} style={style} />
    </div>
  );
}

export function SelectionCategoryDescriptionPreview({
  align = "center",
  style,
}: {
  align?: "left" | "center" | "right";
  style?: BlockStyle;
}) {
  const cmsNew = useCmsNew();
  const { category } = useSelectionCategoryPreview();
  const html =
    category?.description?.trim() ||
    `<p>${cmsNew("cms.new.auto.text.description", "Description…")}</p>`;

  return (
    <div className={category ? undefined : "opacity-60"}>
      <RichTextBlock body={html} align={align} style={style} />
    </div>
  );
}

export function SelectionCategoryDetailPreview({
  columns = 4,
  displayMode = "grid",
  alignment = "center",
  captionAlign = "left",
  visibility = DEFAULT_SELECTION_VISIBILITY,
  style,
}: {
  columns?: 2 | 3 | 4;
  displayMode?: SelectionDisplayMode;
  alignment?: SelectionAlignment;
  captionAlign?: "left" | "center" | "right";
  visibility?: SelectionVisibility;
  style?: BlockStyle;
}) {
  const cmsNew = useCmsNew();
  const { category } = useSelectionCategoryPreview();

  if (!category) {
    return (
      <div className="flex w-full flex-col gap-6 py-6 opacity-60">
        <p className="text-center text-xs text-slate-400">
          {cmsNew("cms.new.auto.action.back", "← Retour")}
        </p>
        <div className="flex gap-8 items-center opacity-60">
          {[1, 2, 3, 4].map((n) => (
            <div
              key={n}
              className="aspect-square rounded bg-slate-100"
              style={{ width: "22%" }}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-6 py-6">
      <p className="text-center text-xs text-slate-400">
        {cmsNew("cms.new.auto.action.back", "← Retour")}
      </p>
      <ArtworkSelectionPreview
        items={category.items}
        columns={columns}
        displayMode={displayMode}
        alignment={alignment}
        captionAlign={captionAlign}
        visibility={visibility}
        style={style}
      />
    </div>
  );
}
